/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers would not be hot-reloadable
 */

import { combineReducers } from 'redux';
import table from './tableReducer';

export default combineReducers({
  table,
});



// WEBPACK FOOTER //
// ./app/reducers/index.js